import React from 'react'
import { Banner } from '../components/template'
const Login = () => {
  return (
    <div>    <Banner/>
</div>
  )
}

export default Login